import React, { createContext, useContext, forwardRef } from 'react';
import { FixedSizeList } from 'react-window';

const LISTBOX_PADDING = 8; // px
const ITEMS_COUNT = 8;
const ITEMS_SIZE = 48;

const OuterElementContext = createContext({});

const OuterElementType = forwardRef((props, ref) => {
  const outerProps = useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function renderRow(props) {
  const { data, index, style } = props;
  const dataRow = data[index];

  return React.cloneElement(dataRow, {
    style: {
      ...style,
      top: style.top + LISTBOX_PADDING
    }
  });
}

const NRVirtualizedListBox = forwardRef(function VirtualizedListbox(props, ref) {
  const { children, ...other } = props;
  const itemData = React.Children.toArray(children);
  const itemCount = itemData.length;

  const getHeight = () => {
    if (itemCount > ITEMS_COUNT) {
      return ITEMS_COUNT * ITEMS_SIZE;
    }
    return itemCount * ITEMS_SIZE;
  };

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <FixedSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={ITEMS_SIZE}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </FixedSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

export default NRVirtualizedListBox;
